import { createUseStyles } from "react-jss";
import * as ErrorTokens from "../../../theme/errorThemeTokens";
import type { Theme } from "../../../types/Theme";

/** Vertical outer margin matches legacy horizontal inset (same px as horizontal banner padding). */
function bannerMarginY(theme: Theme): number {
    return theme.QuestionSpacing.BetweenComponents as number;
}

export default createUseStyles({
    icon: {
        composes: "error__icon",
        display: "inline-block",
        marginRight: ({ theme }: { theme: Theme }) => theme.ErrorBannerPaddingX as number,
        verticalAlign: "middle",
        color: ({ theme }: { theme: Theme }) => ErrorTokens.resolveErrorBannerForeground(theme),
    },
    /** Legacy page error (Font Awesome); not used when UseModernTheme. */
    iconFontAwesome: {
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.ErrorIconSize ??
            (theme.PageErrorFontSize != null ? Math.round(theme.PageErrorFontSize * 1.875) : 30),
    },
    /** New theme page error (inline SVG). */
    iconSvg: {
        width: 20,
        height: 20,
        flexShrink: 0,
    },
    errorContainer: {
        composes: "error__container",
        /** New theme: bordered banner — include border in box model so height/width math matches padding. */
        boxSizing: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme ? ("border-box" as const) : undefined,
        height: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme ? 50 : undefined,
        background: ({ theme }: { theme: Theme }) => ErrorTokens.resolveErrorBannerBackground(theme),
        borderRadius: ({ theme }: { theme: Theme }) => theme.UseModernTheme ? theme.BorderRadius : 10,
        color: ({ theme }: { theme: Theme }) => ErrorTokens.resolveErrorBannerForeground(theme),
        border: ({ theme }: { theme: Theme }) =>
            ErrorTokens.resolveErrorBannerBorder(theme) ?? "none",
        marginTop: ({ theme }: { theme: Theme }) => bannerMarginY(theme),
        marginRight: 0,
        marginBottom: ({ theme }: { theme: Theme }) =>
            theme.UseModernTheme ? 0 : bannerMarginY(theme),
        marginLeft: 0,
        padding: ({ theme }: { theme: Theme }) => [
            [theme.ErrorBannerPaddingY as number, theme.ErrorBannerPaddingX as number],
        ],
        display: "flex",
        alignItems: "center",
    },
    errorMessage: {
        composes: "error__message",
        fontWeight: ({ theme }: { theme: Theme }) => theme.ErrorFontWeight ?? 700,
        verticalAlign: "middle",
        color: ({ theme }: { theme: Theme }) => ErrorTokens.resolveErrorBannerForeground(theme),
        fontSize: ({ theme }: { theme: Theme }) =>
            theme.PageErrorFontSize != null ? theme.PageErrorFontSize : "inherit",
    },
});
